/**
 * 传感器类型图标转换
 */

export const sensorType = {
  1: {
    title: 'sensorType.ZigBeeTemp',
    icon: 'iconfont icon-wenduji icon'
  },
  2: {
    title: 'sensorType.ZigBeeTempHum',
    icon: 'iconfont icon-wenshiduji icon'
  },
  3: {
    title: 'sensorType.LoraTemp',
    icon: 'iconfont icon-wenduji1 icon'
  },
  4: {
    title: 'sensorType.LoraTempHum',
    icon: 'iconfont icon-wenshiduji1 icon'
  },
  5: {
    title: 'sensorType.ZetaTemp',
    icon: 'iconfont icon-21pingjunqiwen icon'
  },
  6: {
    title: 'sensorType.ZetaTempHum',
    icon: 'iconfont icon-wenshiduji2 icon'
  },
  7: {
    title: 'sensorType.ZigBee2Temp',
    icon: 'iconfont icon-zigbee2temp icon'
  },
  8: {
    title: 'sensorType.ZigBee2TempHum',
    icon: 'iconfont icon-zigbee2temphum icon'
  },
  9: {
    title: 'sensorType.FourGTemp',
    icon: 'iconfont icon-fourgtemp icon'
  },
  10: {
    title: 'sensorType.FourGTempHum',
    icon: 'iconfont icon-fourgtemphum icon'
  },
  11: {
    title: 'sensorType.FourGTempGps',
    icon: 'iconfont icon-fourgtemp icon'
  },
  12: {
    title: 'sensorType.FourGTempHumGps',
    icon: 'iconfont icon-fourgtemphum icon'
  }
}

/**
 * 4G传感器报警级别
 */
export const fourGSensorAlarmLevel = {
  0: { title: 'public.close'  },
  1: { title: 'integration.audio_alarm' },
  2: { title: 'integration.light_alarm' },
  3: { title: 'integration.sound_light_alarm' }
}
export const sensorTypeConvert = function (type) {
  type = String(type)
  return sensorType[type] || {}
}
